import { render } from "./staff-base-form.vue?vue&type=template&id=023752f0&ts=true"
import script from "./staff-base-form.vue?vue&type=script&lang=ts"
export * from "./staff-base-form.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__